import { ActionType } from '../constants';

export const defaultOperatorByActionType = {
  [ActionType.TAG]: 'lt',
  [ActionType.OUTCOME_REASON]: 'e',
};

export const defaultOperatorByDataType = {
  boolean: 'e',
  string: 'e',
  integer: 'lt',
  decimal: 'lt',
  date: 'lt',
  timestamp: 'lt',
  reasoncodes: 'in',
};
